import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence recharts' harmless "width(-1) and height(-1) of chart should be greater than 0"
// warnings that fire on ResponsiveContainer's initial mount before layout resolves.
// This is cosmetic-only; charts render correctly after the first ResizeObserver tick.
const _origWarn = console.warn.bind(console);
console.warn = (...args) => {
  const first = args[0];
  if (typeof first === "string" && first.includes("chart should be greater than 0")) return;
  _origWarn(...args);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// PWA service worker — only in production builds, not dev (CRA dev server has issues)
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
